import React from 'react';

import NextImage from 'next/image';

import { Text } from '../../../../components/Text/Text';
import mapMenuMobileLine from '../../assets/mapMenuMobileLine.svg';

import { LayerButtons } from './LayerMenu/LayerButtons';
import { MapDrawerMenu } from './MapDrawerMenu/MapDrawerMenu';

export const MapMenu = () => (
  <div className="scrollbar-none flex w-screen flex-row gap-2 overflow-x-scroll py-4 sm:w-[84px] sm:flex-col sm:overflow-x-auto sm:py-0">
    <div className="flex basis-1 flex-row sm:flex-col">
      <MapDrawerMenu />
    </div>
    {/* MOBILE ONLY */}
    <div className="mr-2 flex sm:hidden">
      <NextImage
        alt="Map menu divider"
        width={1}
        height={58}
        src={mapMenuMobileLine}
        className="max-w-none self-center"
      />
    </div>
    {/* NON-MOBILE ONLY */}
    <Text as="div" variant="sm" className="mt-auto mb-2 hidden text-center font-semibold sm:block">
      Map layers
    </Text>
    <div className="mr-2 flex basis-1 flex-row items-center gap-2 sm:mr-0 sm:mb-10 sm:flex-col">
      <LayerButtons />
    </div>
  </div>
);
